import React, { useContext } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { fromJS } from 'immutable';

import { useLayoutContext, MainLayout, MobileMainLayout } from '@views/layouts';
import Breadcrumb from '@views/modules/category/sub-modules/breadcrumb';
import Category from '@views/modules/category';
import Sitemap from '@views/modules/sitemap';
import Placeholder from '@views/modules/category/placeholder';
import Error from '@views/modules/error';

import useCategory from '@views/modules/category/hooks/use-category';
import _getId from '@helpers/get-id-from-slug';

export const CategoryPage: NextPage = (): JSX.Element => {
  const router = useRouter();
  const categoryId = _getId(router.query.slug);
  const { category, loading, error } = useCategory(categoryId);
  const data = fromJS(category);

  return (
    <MainLayout
      title="Danh mục"
      breadcrumb={
        <Breadcrumb
          id={categoryId}
          data={data}
          loading={loading}
          error={error}
        />
      }
    >
      {loading ? (
        <Placeholder />
      ) : (
        <>
          {error ? (
            <Error statusCode={404} />
          ) : (
            <Category id={categoryId} data={data} />
          )}
        </>
      )}
    </MainLayout>
  );
};

export const CategoryListPage: NextPage = (): JSX.Element => {
  return (
    <MobileMainLayout>
      <Sitemap />
    </MobileMainLayout>
  );
};

export default CategoryPage;
